// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"9cb6846f","453":"03b71181","627":"e77c6711","738":"b7812674","923":"45f2408f"}[chunkId] + ".chunk.js";
};